import { encryptByMd5 } from '@aomi/utils'

/**
 * 生成签名
 * @param method - 请求方法 'GET' | 'POST'
 * @param signParams - 签名参数 包括请求头和请求参数
 * @param tempKey - 签名key 来源于tempKey或SDKKey
 * @returns
 */
export const generateSign = (method = 'GET', signParams, tempKey: string): string => {
  return method && generateSignForGet(signParams, tempKey)
  // if (method.toUpperCase() === 'GET') return generateSignForGet(signParams, tempKey);

  // return genSignForPost(signParams, tempKey);
}

/**
 * get方式签名
 * @param signParams
 * @param secKey
 * @returns
 */
const generateSignForGet = (signParams = {} as any, secKey: string) => {
  let signStr = ''

  for (const key of Object.keys(signParams).sort()) {
    if (signParams[key]) {
      signStr += `${key}=${signParams[key]}&`
    }
  }

  const signArr = signStr.split('&')
  signArr.pop()

  console.log('[签名key] ', secKey)
  console.log('[签名参数] ', signArr)
  return encryptByMd5(signArr.join('&') + secKey)
}

// ott-lifepay的签名逻辑，签名规则以后会改成这种
// function genSignForGet(signParams, tempKey) {
//   const { url, headers, params } = signParams;
//   if (!params) return '';
//   const apiPath = LIFEPAY_SERVICE + url;
//   const paramsStr = qs.stringify(params, { skipNulls: true });
//   if (!paramsStr) return '';
//   const signStr = `${apiPath}\nsessionid=${headers.sessionId}&${paramsStr}\n${tempKey}`;
//   return md5(signStr);
// }

// /**
//  * post方式签名
//  * @param params
//  * @param tempKey
//  * @returns
//  */
// function genSignForPost(params, tempKey) {
//   const { url, headers, data } = params
//   if (!data) return ''
//   const apiPath = LIFEPAY_SERVICE + url

//   let dataJson = data
//   if (typeof data !== 'string') {
//     dataJson = JSON.stringify(data)
//   }
//   const dataStr = window.btoa(md5(dataJson))
//   const signStr = `${apiPath}\nsessionid=${headers.sessionId}\n${dataStr}\n${tempKey}`
//   return md5(signStr)
// }
